import ajaxRequest, { requestType } from "./ajax";

export class LoginService {

    async changeTempAccessTokenState(device_id: string, state: string) {
        const data = {
            device_id:device_id,
            state:state
        };
        return await ajaxRequest('/data/api.login/changeTempAccessTokenState', data, requestType.POST);
    }

    async verifyTokenWithUserInfo(device_id:string, phone:string, password:string){
        const data = {
            device_id : device_id,
            phone:phone,
            password:password
        };
        return await ajaxRequest('/data/api.login/verifyTokenWithUserInfo', data, requestType.POST);
    }
}